import { ethers } from 'ethers'
import { useEffect, useState } from 'react'

import {
  totalFeesQuery,
  totalInterest,
  totalSupplyQuery,
  totalUsers,
  totalVolumeQuery,
} from './queries'
import { createClient } from '../useClient'
import { MOONBEAM } from '../../config/chains'
import { SUBGRAPH_URLS } from '../../config/subgraphs'
import { GLP_DECIMALS, USD_DECIMALS } from '../const'

export default function useOverview() {
  const [volume, setVolume] = useState(0)
  const [fees, setFees] = useState(0)
  const [supply, setSupply] = useState(0)
  const [interest, setInterest] = useState(0)
  const [userCount, setUserCount] = useState(0)
  const client = createClient(SUBGRAPH_URLS[MOONBEAM].stats)

  const _getTotalVolume = async (client) => {
    client.query({ query: totalVolumeQuery }).then(({ data }) => {
      const { volumeStat } = data
      const margin = parseFloat(
        ethers.utils.formatUnits(volumeStat.margin, USD_DECIMALS)
      )
      const swap = parseFloat(
        ethers.utils.formatUnits(volumeStat.swap, USD_DECIMALS)
      )
      const mint = parseFloat(
        ethers.utils.formatUnits(volumeStat.mint, USD_DECIMALS)
      )
      const burn = parseFloat(
        ethers.utils.formatUnits(volumeStat.burn, USD_DECIMALS)
      )

      setVolume(margin + swap + mint + burn)
    })
  }

  const _getTotalFees = async (client) => {
    client.query({ query: totalFeesQuery }).then(({ data }) => {
      const { feeStat } = data
      const margin = parseFloat(
        ethers.utils.formatUnits(feeStat.margin, USD_DECIMALS)
      )
      const swap = parseFloat(
        ethers.utils.formatUnits(feeStat.swap, USD_DECIMALS)
      )
      const mint = parseFloat(
        ethers.utils.formatUnits(feeStat.mint, USD_DECIMALS)
      )
      const burn = parseFloat(
        ethers.utils.formatUnits(feeStat.burn, USD_DECIMALS)
      )

      setFees(margin + swap + mint + burn)
    })
  }

  const _getTotalSupply = async (client) => {
    client.query({ query: totalSupplyQuery }).then(({ data }) => {
      const { glpStat } = data
      setSupply(
        parseFloat(ethers.utils.formatUnits(glpStat.glpSupply, GLP_DECIMALS))
      )
    })
  }

  const _getTotalInterest = async (client) => {
    client.query({ query: totalInterest }).then(({ data }) => {
      const { tradingStat } = data
      const long = parseFloat(
        ethers.utils.formatUnits(tradingStat.longOpenInterest, USD_DECIMALS)
      )
      const short = parseFloat(
        ethers.utils.formatUnits(tradingStat.shortOpenInterest, USD_DECIMALS)
      )
      setInterest(long + short)
    })
  }

  const _getTotalUsers = async (client) => {
    client.query({ query: totalUsers }).then(({ data }) => {
      const { userStat } = data
      const cnt = parseInt(userStat.uniqueCount)
      setUserCount(cnt)
    })
  }

  useEffect(() => {
    const getTotals = async () => {
      await Promise.all([
        _getTotalVolume(client),
        _getTotalFees(client),
        _getTotalSupply(client),
        _getTotalInterest(client),
        _getTotalUsers(client),
      ])
    }

    getTotals()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    volume: volume,
    fees: fees,
    supply: supply,
    interest: interest,
    users: userCount,
  }
}
